import store from "../../store/store"
import { ResponseCode, QweMessage } from "../../common/constant"
import nProgress from "../progress"
import { RequestData,Response,RequestMethods } from "./index"
import Axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { stringify } from "qs";
import { ElMessage } from "element-plus";

const defaultConfig: AxiosRequestConfig = {
    baseURL: store.state.baseUrl,
    timeout: 100000,
    headers: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": 'application/x-www-form-urlencoded',
      "X-Requested-With": "XMLHttpRequest"
    },
    // 数组格式参数序列化
    paramsSerializer: params => stringify(params, { indices: false }),
    withCredentials:true
  };

class qweHttp {
    constructor() {
        
    }

    private static axiosInstance: AxiosInstance = Axios.create(defaultConfig);

    public request<T> (
        method:RequestMethods,
        url:string,
        data:object,
        showProgress:boolean = true,
        isJson:boolean = false,
        isNoticeConfirm:boolean = false,
        axiosConfig?:AxiosRequestConfig,
    ):Promise<Response<T>>{
        (data as RequestData)["__RequestVerificationToken"] = store.state.requestVerificationToken;
        if (showProgress) {
            nProgress.start();
        }

        let postData;

        if(!isJson){
            postData = stringify(data, { arrayFormat : 'indices' })
        }
        else{
            postData = JSON.stringify(data);
        }

        const config = {
            baseURL:store.state.baseUrl,
            method,
            url,
            data: postData,
            ...axiosConfig
        } as AxiosRequestConfig;

        return new Promise(function (resolve, reject) {
            qweHttp.axiosInstance.request(config)
            .then(axiosResponse =>{
                if (showProgress) {
                    nProgress.done();
                }
                let data = axiosResponse.data as Response<T>;
                switch (data.Code) {
                    case ResponseCode.UnLogin:
                        if(!store.state.externalState){
                            store.commit("LogOut", false);
                        }
                        reject(data);
                        break;
                    case ResponseCode.UnAuthoized:
                        store.commit("UnAuthoized");
                        reject(data);
                        break;
                    case ResponseCode.NotFound:
                        store.commit("NotFound");
                        reject(data);
                        break;
                    case ResponseCode.Success:
                        resolve(data);
                        break;
                    case ResponseCode.SuccessAndWarn:
                        store.commit("SetWarnState", data.WarnMessages);
                        resolve(data);
                        break;
                    case ResponseCode.Error:
                        let result = {
                            "WarnMessages": data.WarnMessages,
                            "ErrorMessages": data.ErrorMessages,
                            "NoticeNeedConfirm":isNoticeConfirm
                        }
                        store.commit("SetErrorState",result);
                        reject(data);
                        break;
                }
            })
            .catch(x=>{
                let Response = {
                    Code:ResponseCode.NetWorkError,
                    Result:x
                }
                if (showProgress) {
                    nProgress.done();
                }
                ElMessage.error({
                    message: QweMessage.NetWorkError,
                    grouping: true
                });
                reject(Response);
            })
        })
    }

    public post<T>(
        url: string,
        data:object,
        showProgress:boolean = false,
        isNoticeConfirm:boolean = false,
        axiosConfig?: AxiosRequestConfig
     ) {
        return this.request<T>("post", url, data, showProgress, false, isNoticeConfirm, axiosConfig);
    }

    public get<T>(
        url : string,
        data : object,
        showProgress:boolean,
        isNoticeConfirm:boolean = false,
        axiosConfig?: AxiosRequestConfig
     ) {
        return this.request<T>("get", url, data, showProgress, false, isNoticeConfirm, axiosConfig);
    }

    public postByJson( 
        url:string,
        data:object,
        showProgress:boolean,
        isNoticeConfirm:boolean = false,
        axiosConfig?: AxiosRequestConfig
     ) {
        let config = {
            headers: {
                "Accept": "application/json, text/plain, */*",
                "Content-Type": 'application/json',
                "X-Requested-With": "XMLHttpRequest"
            },
            ...axiosConfig
        } as AxiosRequestConfig
        return this.request("post", url, data, showProgress, true, isNoticeConfirm, config);
    }

    public uploadFile(
        url:string,
        contentType:string,
        fieldName:string,
        file:File,
        fileName:string
    ){
        let myFormData = new FormData();
        myFormData.append("contentType", contentType);
        myFormData.append("fieldName", fieldName);
        myFormData.append("__RequestVerificationToken", store.state.requestVerificationToken);
        myFormData.append("files", file, fileName);

        let headers = {
            "Content-Type": 'multipart/form-data',
        }

        let config = {
            baseURL:store.state.baseUrl,
            method:"post",
            url,
            headers,
            data:myFormData
        } as AxiosRequestConfig;

        return new Promise(function (resolve, reject) {
            qweHttp.axiosInstance.request(config).then(
                x=> resolve(x.data)
            ).catch(e=>{
                console.log(e);
                let Response = {
                    Code:ResponseCode.NetWorkError,
                    Result:e
                }
                ElMessage.error({
                    message: QweMessage.NetWorkError,
                    grouping: true
                });
                reject(Response);
            })
        });
    }
}

const http = new qweHttp();
export default http;